<template>
  <div>
    <CCard>
      <Device ref="deviceView" @change="onChangedSite" prefix="thcs_"/>
    </CCard>

    <Event ref="eventView" @click="onClickEvent" prefix="thcs_"/>

    <EventDialog ref="eventDialog" />
  </div>
</template>

<script>
import Dashboard from "@/views/btfs/Dashboard"
import Event from "@/views/thcs/Event";

export default {
  name: "THCSDashboard",
  extends: Dashboard,
    components: {
    Event
  },
};
</script>
